import {SERVICE_NAMES} from '../constants';
import {createApiCall} from '../utils';
import type {ServiceName} from '../constants';
import type {
    ApiCallOptions,
    LoginRequest,
    LoginResponse,
    TwoFactorChallengeResource,
    TwoFactorVerifyRequest,
    OAuthTokenResource,
    TwoFactorStatusResource,
    TwoFactorSetupResource,
    TwoFactorSetupVerifyRequest,
    BackupCodesResource,
    TwoFactorDisableRequest,
    RegenerateBackupCodesRequest,
    TwoFactorResetRequest
} from './api.d';

const createTwoFactorApiCall = <T = any>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
    endpoint: string
) => createApiCall<T>(SERVICE_NAMES.TWO_FACTOR as ServiceName, method, endpoint);

export const twoFactorApi = {
    login: ({data, options}: {data: LoginRequest; options?: ApiCallOptions}) =>
        createTwoFactorApiCall<LoginResponse>('POST', 'auth/login')({...options, data}),

    verifyTwoFactor: ({data, options}: {data: TwoFactorVerifyRequest; options?: ApiCallOptions}) =>
        createTwoFactorApiCall<OAuthTokenResource>('POST', 'auth/2fa/verify')({...options, data}),

    getTwoFactorStatus: ({options}: {options?: ApiCallOptions} = {}) =>
        createTwoFactorApiCall<TwoFactorStatusResource>('GET', '2fa/status')({...options}),

    getTwoFactorSetup: ({options}: {options?: ApiCallOptions} = {}) =>
        createTwoFactorApiCall<TwoFactorSetupResource>('GET', '2fa/setup')({...options}),

    verifyTwoFactorSetup: ({data, options}: {data: TwoFactorSetupVerifyRequest; options?: ApiCallOptions}) =>
        createTwoFactorApiCall<BackupCodesResource>('POST', '2fa/setup/verify')({...options, data}),

    disableTwoFactor: ({data, options}: {data: TwoFactorDisableRequest; options?: ApiCallOptions}) =>
        createTwoFactorApiCall<void>('POST', '2fa/disable')({...options, data}),

    getBackupCodes: ({options}: {options?: ApiCallOptions} = {}) =>
        createTwoFactorApiCall<BackupCodesResource>('GET', '2fa/backup-codes')({...options}),

    regenerateBackupCodes: ({data, options}: {data: RegenerateBackupCodesRequest; options?: ApiCallOptions}) =>
        createTwoFactorApiCall<BackupCodesResource>('POST', '2fa/backup-codes')({...options, data}),

    requestTwoFactorReset: ({data, options}: {data: TwoFactorResetRequest; options?: ApiCallOptions}) =>
        createTwoFactorApiCall<void>('POST', 'auth/2fa/reset-request')({...options, data, useS2SAuth: true}),

    dismissTwoFactorSetup: ({options}: {options?: ApiCallOptions} = {}) =>
        createTwoFactorApiCall<void>('POST', '2fa/dismiss')({...options}),

    disableTwoFactorForUser: ({userId, options}: {userId: string; options?: ApiCallOptions}) =>
        createTwoFactorApiCall<void>('POST', `2fa/users/${userId}/disable`)({...options})
};

export function getIsTwoFactorChallenge(
    response: LoginResponse
): response is {data: TwoFactorChallengeResource} {
    return 'challenge_token' in (response as any).data;
}
